import React from "react";
import { Container } from "react-bootstrap";

import "./Areas.scss";
import AreasList from "../LisbonMap/components/AreasList/AreasList";

const Areas = () => {
  return (
    <div className="section areas-page" id="areas">
      <Container>
        <div className="main-heading">
          <h1>Discover Recycling in Your Area</h1>
          <p>
            Find nearby recycling bins, learn about local green initiatives, and
            be part of the positive change in Portugal.
          </p>
        </div>
        <AreasList />
      </Container>
    </div>
  );
};

export default Areas;
